module.exports = __webpack_public_path__ + "static/media/pexels-photo-530024.69bbaafa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/002_be/pexels-photo-530024.jpeg
// module id = 768
// module chunks = 0